module.exports = __webpack_public_path__ + "static/media/completeEvent.199a0d86.svg";